import { Select } from 'ts/interfaces/Generic';
import { Validation } from 'ts/interfaces/Validation';
import { faBahtSign, faEur, faGbp, faUsd } from '@fortawesome/free-solid-svg-icons';

export const flyeastCompanyId = 108;
export const loginHubUrl = 'https://b2blogin.beprotravel.com';
export const blobPath = '/backend';
export const credentialsValidation: Validation = {
  username: { required: true },
  password: { required: true },
};

export const contactUsValidation: Validation = {
  firstName: { required: true, maxLength: 30 },
  phone: { required: true, numbers: true, minLength: 10, maxLength: 20 },
  email: { required: true, email: true },
  message: { required: true },
};

export const cancelOrderValidation: Validation = {
  firstName: { required: true, maxLength: 30 },
  lastName: { required: true, maxLength: 30 },
  idNumber: { required: true, length: 9, numbers: true },
  orderId: { required: true, numbers: true },
  phone: { required: true, numbers: true },
  email: { required: true, email: true },
  message: { required: true },
};

export const userB2CValidation: Validation = {
  firstName: { required: true, minLength: 2, maxLength: 20, english: true },
  lastName: { required: true, minLength: 2, maxLength: 20, english: true },
  email: { required: true, email: true },
  workTel: { required: true, numbers: true, minLength: 9, maxLength: 11 },
  mobile: { required: true, numbers: true, minLength: 9, maxLength: 11 },
};

export const branchB2CValidation: Validation = {
  branchTitle: { required: true, minLength: 2, maxLength: 20 },
  branchDesc: { required: true, minLength: 2, maxLength: 20 },
  city: { minLength: 2, maxLength: 20 },
  address: { minLength: 2, maxLength: 100 },
  tel1: { required: true, numbers: true, minLength: 9, maxLength: 11 },
  email1: { required: true, email: true },
};

export enum PaymentType {
  Normal = 'Normal',
  Credit = 'Credit',
}

export const displayStyles = [
  { value: '1', label: 'hotel.view_1' },
  { value: '2', label: 'hotel.view_2' },
];

export const displayModes = [
  {
    value: 7,
    label: 'hotel.professional_v3',
  },
  {
    value: 13,
    label: 'hotel.professional_v4',
  },
  {
    value: 10,
    label: 'hotel.professional_v3_multi',
  },
  {
    value: 14,
    label: 'hotel.professional_v4_multi',
  },
  {
    value: 8,
    label: 'hotel.business_new',
  },
  {
    value: 9,
    label: 'hotel.price_new',
  },
  {
    value: 11,
    label: 'hotel.business_new_multi',
  },
  {
    value: 12,
    label: 'hotel.price_new_multi',
  },
  {
    value: 15,
    label: 'hotel.professional_single',
  },
  {
    value: 17,
    label: 'hotel.professional_single_multi',
  },
  {
    value: 16,
    label: 'hotel.professional_single_2',
  },
];

export type DisplayModeOption = {
  value: number;
  multiValue?: number;
  label: string;
  multiLabel?: string;
};

export const displayModePrimaryOptions: DisplayModeOption[] = [
  {
    value: 7,
    multiValue: 10,
    label: 'hotel.professional_v3',
    multiLabel: 'hotel.professional_v3_multi',
  },
  {
    value: 13,
    multiValue: 14,
    label: 'hotel.professional_v4',
    multiLabel: 'hotel.professional_v4_multi',
  },
  {
    value: 8,
    multiValue: 11,
    label: 'hotel.business_new',
    multiLabel: 'hotel.business_new_multi',
  },
  {
    value: 9,
    multiValue: 12,
    label: 'hotel.price_new',
    multiLabel: 'hotel.price_new_multi',
  },
];

export const displayModeOldOptions: DisplayModeOption[] = [
  {
    value: 15,
    multiValue: 17,
    label: 'hotel.professional_single',
    multiLabel: 'hotel.professional_single_multi',
  },
  {
    value: 16,
    label: 'hotel.professional_single_2',
  },
];

export const getHotelDisplayModeSettings = (value: number) => {
  if (value === 3) {
    return { displayMode: value, isShortMode: true, isCubeDesign: false, isCubeDesignByEat: true };
  }
  if (value === 4) {
    return { displayMode: value, isShortMode: true, isCubeDesign: true, isCubeDesignByEat: false };
  }
  if (value === 5) {
    return { displayMode: value, isShortMode: false, isCubeDesign: false, isCubeDesignByEat: true };
  }
  if (value === 6) {
    return { displayMode: value, isShortMode: false, isCubeDesign: true, isCubeDesignByEat: false };
  }
  if ([7, 8, 9].includes(value)) {
    return { displayMode: value, isShortMode: true, isCubeDesign: true, isCubeDesignByEat: false };
  }
  if ([10, 11, 12, 13, 14, 15, 16, 17].includes(value)) {
    return { displayMode: value, isShortMode: true, isCubeDesign: true, isCubeDesignByEat: true };
  }

  return null;
};

export const resolveDisplayModeSelection = (displayMode?: number) => {
  const value = displayMode || 7;

  for (const mode of displayModePrimaryOptions) {
    if (mode.value === value) {
      return { baseValue: mode.value, isMultiPrice: false, isOldDisplay: false };
    }
    if (mode.multiValue === value) {
      return { baseValue: mode.value, isMultiPrice: true, isOldDisplay: false };
    }
  }

  for (const mode of displayModeOldOptions) {
    if (mode.value === value) {
      return { baseValue: mode.value, isMultiPrice: false, isOldDisplay: true };
    }
    if (mode.multiValue === value) {
      return { baseValue: mode.value, isMultiPrice: true, isOldDisplay: true };
    }
  }

  return { baseValue: 7, isMultiPrice: false, isOldDisplay: false };
};

export const getDisplayModeValue = (
  baseValue: number,
  isMultiPrice: boolean,
  isOldDisplay: boolean
) => {
  const options = isOldDisplay ? displayModeOldOptions : displayModePrimaryOptions;
  const mode = options.find((item) => item.value === baseValue) || options[0];

  if (isMultiPrice && mode.multiValue !== undefined) {
    return mode.multiValue;
  }

  return mode.value;
};

export const normalizeHotelDisplaySettings = (displayMode?: number) => {
  if (displayMode !== undefined && displayModes.some((mode) => mode.value === displayMode)) {
    return { displayMode };
  }

  return getHotelDisplayModeSettings(7)!;
};

export const roomModes = [
  { value: 0, label: 'hotel.internal' },
  { value: 2, label: 'hotel.tab' },
];

export const hotelCardStyles = [
  { value: 0, label: 'Background' },
  { value: 1, label: 'Border' },
];

export const searchTypeIds: Select[] = [
  { value: '138', label: 'DEFAULT' },
  { value: '120', label: 'M+GTO' },
  { value: '162', label: 'M+EH' },
  { value: '165', label: 'M+EHT' },
  { value: '170', label: 'M+GTOEH' },
  { value: '105', label: 'PREFERRED' },
  { value: '0', label: 'ALL' },
  { value: '141', label: 'M+E' },
];
export const availableLanguages = [
  { lang: 'en', country: 'us', name: 'English' },
  { lang: 'he', country: 'il', name: 'עברית' },
  { lang: 'es', country: 'es', name: 'Español' },
  { lang: 'it', country: 'it', name: 'Italiano' },
  { lang: 'fr', country: 'fr', name: 'Français' },
];

export const proposalTemplates = [
  { value: 't1', label: 'proposal.simple_template' },
  { value: 't2', label: 'proposal.colorful_template' },
  { value: 't3', label: 'proposal.contrast_template' },
];
export const proposalSortOptions = [
  { value: '1', label: 'proposal.by_order_id' },
  { value: '2', label: 'proposal.by_service_date' },
  { value: '3', label: 'proposal.original' },
];

export const titlePassengerOptions = [
  { value: 'mr', label: 'passenger.mr' },
  { value: 'mrs', label: 'passenger.mrs' },
  { value: 'miss', label: 'passenger.miss' },
  { value: 'ms', label: 'passenger.ms' },
  { value: 'dr', label: 'passenger.dr' },
  { value: 'prof', label: 'passenger.prof' },
  { value: 'child', label: 'child' },
];

export const paxTypeOptions = [
  { value: 'ADT', label: 'Adult' },
  { value: 'CNN', label: 'Child' },
  { value: 'SN', label: 'Senior' },
  { value: 'YTH', label: 'Youth' },
  { value: 'INF', label: 'Infant' },
  { value: 'INS', label: 'Ins' },
];

export const getGender = () => [
  { value: 'M', label: 'male' },
  { value: 'F', label: 'female' },
];

export const moManualRoomTypeOptions = [
  { value: 'O1A0C', label: 'O1A0C - 1 Adult', data: { numAdt: 1, numCnn: 0 } },
  { value: 'O2A0C', label: 'O2A0C - 2 Adults', data: { numAdt: 2, numCnn: 0 } },
  { value: 'O2A1C', label: 'O2A1C - 2 Adults plus 1 Child', data: { numAdt: 2, numCnn: 1 } },
  { value: 'O2A2C', label: 'O2A2C - 2 Adults plus 2 Children', data: { numAdt: 2, numCnn: 2 } },
  { value: 'O2A3C', label: 'O2A3C - 2 Adults plus 3 Children', data: { numAdt: 2, numCnn: 3 } },
  { value: 'O2A4C', label: 'O2A4C - 2 Adults plus 4 Children', data: { numAdt: 2, numCnn: 4 } },
  { value: 'O3A0C', label: 'O3A0C - 3 Adults', data: { numAdt: 3, numCnn: 0 } },
  { value: 'O3A1C', label: 'O3A1C - 3 Adults plus 1 Child', data: { numAdt: 3, numCnn: 1 } },
  { value: 'O3A2C', label: 'O3A2C - 3 Adults plus 2 Children', data: { numAdt: 3, numCnn: 2 } },
  { value: 'O3A3C', label: 'O3A3C - 3 Adults plus 3 Children', data: { numAdt: 3, numCnn: 3 } },
  { value: 'O3A4C', label: 'O3A4C - 3 Adults plus 4 Children', data: { numAdt: 3, numCnn: 4 } },
  { value: 'O4A0C', label: 'O4A0C - 4 Adults', data: { numAdt: 4, numCnn: 0 } },
  { value: 'O4A1C', label: 'O4A1C - 4 Adults plus 1 Child', data: { numAdt: 4, numCnn: 1 } },
  { value: 'O4A2C', label: 'O4A2C - 4 Adults plus 2 Children', data: { numAdt: 4, numCnn: 2 } },
  { value: 'O4A3C', label: 'O4A3C - 4 Adults plus 3 Children', data: { numAdt: 4, numCnn: 3 } },
  { value: 'O4A4C', label: 'O4A4C - 4 Adults plus 4 Children', data: { numAdt: 4, numCnn: 4 } },
  { value: 'O5A0C', label: 'O5A0C - 5 Adults', data: { numAdt: 5, numCnn: 0 } },
  { value: 'O5A1C', label: 'O5A1C - 5 Adults plus 1 Child', data: { numAdt: 5, numCnn: 1 } },
  { value: 'O5A2C', label: 'O5A2C - 5 Adults plus 2 Children', data: { numAdt: 5, numCnn: 2 } },
  { value: 'O5A3C', label: 'O5A3C - 5 Adults plus 3 Children', data: { numAdt: 5, numCnn: 3 } },
  { value: 'O5A4C', label: 'O5A4C - 5 Adults plus 4 Children', data: { numAdt: 5, numCnn: 4 } },
  { value: 'O6A0C', label: 'O6A0C - 6 Adults', data: { numAdt: 6, numCnn: 0 } },
  { value: 'O6A1C', label: 'O6A1C - 6 Adults plus 1 Child', data: { numAdt: 6, numCnn: 1 } },
  { value: 'O6A2C', label: 'O6A2C - 6 Adults plus 2 Children', data: { numAdt: 6, numCnn: 2 } },
  { value: 'O6A3C', label: 'O6A3C - 6 Adults plus 3 Children', data: { numAdt: 6, numCnn: 3 } },
  { value: 'O6A4C', label: 'O6A4C - 6 Adults plus 4 Children', data: { numAdt: 6, numCnn: 4 } },
  { value: 'O7A0C', label: 'O7A0C - 7 Adults', data: { numAdt: 7, numCnn: 0 } },
  { value: 'O7A1C', label: 'O7A1C - 7 Adults plus 1 Child', data: { numAdt: 7, numCnn: 1 } },
  { value: 'O7A2C', label: 'O7A2C - 7 Adults plus 2 Children', data: { numAdt: 7, numCnn: 2 } },
  { value: 'O7A3C', label: 'O7A3C - 7 Adults plus 3 Children', data: { numAdt: 7, numCnn: 3 } },
  { value: 'O7A4C', label: 'O7A4C - 7 Adults plus 4 Children', data: { numAdt: 7, numCnn: 4 } },
  { value: 'O8A0C', label: 'O8A0C - 8 Adults', data: { numAdt: 8, numCnn: 0 } },
  { value: 'O8A1C', label: 'O8A1C - 8 Adults plus 1 Child', data: { numAdt: 8, numCnn: 1 } },
  { value: 'O8A2C', label: 'O8A2C - 8 Adults plus 2 Children', data: { numAdt: 8, numCnn: 2 } },
  { value: 'O8A3C', label: 'O8A3C - 8 Adults plus 3 Children', data: { numAdt: 8, numCnn: 3 } },
  { value: 'O8A4C', label: 'O8A4C - 8 Adults plus 4 Children', data: { numAdt: 8, numCnn: 4 } },
];

export const DEFAULT_CANCELLATION_DATE_DELTA = 3;

export const tripBuilderAdditionalInfoValidation: Validation = {
  firstName: { required: true, minLength: 2, maxLength: 20 },
  email: { email: true },
  password: { minLength: 6, maxLength: 50 },
  expireDate: { required: true },
};

export const isFlyeastSite = (): boolean => {
  try {
    const initSiteData = localStorage.getItem('initSiteData');
    const initJson = JSON.parse(initSiteData || '{}');

    return initJson.companyId === flyeastCompanyId;
  } catch {
    return false;
  }
};

export const getProposalCurrencyOptions = (isFlyeast = isFlyeastSite()): Select[] => {
  if (!isFlyeast) {
    return currenciesList;
  }

  return currenciesList.concat({
    value: 'thb',
    label: '',
    icon: {
      path: faBahtSign,
      className: '',
    },
  });
};

export const currenciesList: Select[] = [
  {
    value: 'usd',
    label: '',
    icon: {
      path: faUsd,
      className: '',
    },
  },
  {
    value: 'eur',
    label: '',
    icon: {
      path: faEur,
      className: '',
    },
  },
  {
    value: 'gbp',
    label: '',
    icon: {
      path: faGbp,
      className: '',
    },
  },
];
